"use client";

import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RoofingHero() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stickers = [{
    label: "NATIONWIDE CASH BUYER",
    rotate: "-rotate-4",
    bg: "bg-[var(--primary)] text-[var(--primary-foreground)]",
    top: "-top-5 left-[8%]"
  }, {
    label: "EXPERT ROOFING",
    rotate: "rotate-3",
    bg: "bg-[var(--secondary)] text-[var(--secondary-foreground)]",
    top: "-top-7 left-1/2 -translate-x-1/2"
  }, {
    label: "EST. 2023",
    rotate: "-rotate-2",
    bg: "bg-[var(--muted)]",
    top: "-top-5 right-[8%]"
  }];
  return <section data-section-id="1717" id="expert-roofing-storm-repair" className="dark relative bg-background overflow-hidden">
      <div className="relative max-w-[1360px] mx-auto px-8 lg:px-12 py-24 md:py-32">
        {}
        <div ref={headRef} className={`flex items-center gap-3 mb-12 md:mb-16 transition-all duration-700 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-mono text-xs md:text-sm font-medium tracking-[0.18em] uppercase text-foreground">
            § 01 / LUXURY CONSTRUCTION
          </span>
          <span className="h-px w-20 bg-foreground" />
        </div>

        {}
        <div className="relative text-center max-w-5xl mx-auto">
          {}
          <div className="hidden md:block absolute -top-6 -left-6 lg:-left-16 text-foreground" aria-hidden="true">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M32 8 L36 28 L56 32 L36 36 L32 56 L28 36 L8 32 L28 28 Z" />
            </svg>
          </div>

          {}
          <div className="hidden md:block absolute -top-4 -right-4 lg:-right-20 text-foreground opacity-90" aria-hidden="true">
            <svg width="90" height="90" viewBox="0 0 90 90" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="35" cy="35" r="22" />
              <circle cx="65" cy="55" r="14" />
              <circle cx="28" cy="65" r="9" />
              <circle cx="30" cy="28" r="3" fill="currentColor" />
              <circle cx="60" cy="50" r="2" fill="currentColor" />
            </svg>
          </div>

          <h1 className={`font-default font-bold text-foreground leading-[0.92] tracking-tight transition-all duration-700 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(3.5rem, 9vw, 8.5rem)"
        }}>
            <span className="block">Trusted roofing.</span>
            <span className="block">
              Fast{" "}
              <span className="relative inline-block">
                <span className="absolute inset-x-[-6px] top-[18%] bottom-[8%] bg-[var(--primary)] -rotate-1 -z-0" aria-hidden="true" />
                <span className="relative z-10">cash offers.</span>
              </span>
            </span>
          </h1>

          <p className={`mt-8 md:mt-10 mx-auto max-w-xl text-[var(--muted-foreground)] font-default text-lg md:text-xl leading-relaxed transition-all duration-700 delay-150 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            Luxury Construction LLC provides professional roofing services in Southwest Kansas and nationwide cash home buying solutions.
          </p>

          {}
          <div className={`mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-5 transition-all duration-700 delay-300 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Button asChild className="bg-[var(--primary)] text-[var(--primary-foreground)] hover:bg-[var(--primary)] border-[3px] border-[var(--foreground)] rounded-lg font-default font-bold text-base px-8 py-6 h-auto hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[0_0_0_var(--foreground)] transition-all duration-150">
              <Link to="/ContactUsPage">
                <Sparkles className="size-5" />
                Get Free Inspection
              </Link>
            </Button>
            <Button asChild className="bg-background text-foreground hover:bg-background border-[3px] border-[var(--foreground)] rounded-lg font-default font-bold text-base px-8 py-6 h-auto hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[0_0_0_var(--foreground)] transition-all duration-150">
              <Link to="/SellYourHouseFastPage">
                Sell Your House Fast
                <ArrowRight className="size-5" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div ref={imgRef} className={`relative mt-20 md:mt-28 transition-all duration-700 delay-200 ${imgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute inset-x-0 -top-2 md:top-0 z-20 pointer-events-none hidden md:block">
            {stickers.map((s, i) => <div key={i} data-index={i} className={`absolute ${s.top} ${s.rotate} ${s.bg} text-foreground border-[2px] border-[var(--foreground)] rounded-md px-4 py-2 font-default text-sm md:text-base shadow-[3px_3px_0_var(--foreground)] whitespace-nowrap`}>
                {s.label}
              </div>)}
          </div>

          {}
          <div className="flex md:hidden flex-wrap justify-center gap-3 mb-6">
            {stickers.slice(0, 2).map((s, i) => <div key={i} data-index={i} className={`${s.rotate} ${s.bg} text-foreground border-[2px] border-[var(--foreground)] rounded-md px-3 py-1.5 font-default text-xs shadow-[3px_3px_0_var(--foreground)] whitespace-nowrap`}>
                {s.label}
              </div>)}
          </div>

          {}
          <div className="relative border-[4px] border-[var(--foreground)] rounded-lg overflow-hidden bg-[var(--accent)]">
            <div className="aspect-[16/9] w-full">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/luxury_roofing_project_kansas.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/luxury_roofing_project_kansas.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/luxury_roofing_project_kansas.png-wvc-sizes" alt="Professional roofing installation on a residential home in Kansas" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            </div>
          </div>

          {}
          <div className="hidden md:block absolute -bottom-10 -left-8 lg:-left-16 text-foreground -rotate-12" aria-hidden="true">
            <svg width="140" height="140" viewBox="0 0 140 140" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M70 130 C70 130 70 90 60 70 C50 50 30 40 20 30" />
              <path d="M55 80 C40 75 25 70 15 55 C28 55 42 60 55 70" fill="var(--secondary)" fillOpacity="0.4" />
              <path d="M62 95 C45 92 30 85 18 72 C32 70 48 75 62 85" fill="var(--secondary)" fillOpacity="0.4" />
              <path d="M68 110 C50 108 35 100 22 88 C36 87 54 92 68 100" fill="var(--secondary)" fillOpacity="0.4" />
              <path d="M58 65 C45 60 32 50 22 35 C36 36 50 45 60 55" fill="var(--secondary)" fillOpacity="0.4" />
            </svg>
          </div>

          {}
          <div className="hidden md:block absolute -bottom-6 -right-4 lg:-right-12 text-[var(--primary)]" aria-hidden="true">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
              <path d="M28 6 L28 22 M28 34 L28 50 M6 28 L22 28 M34 28 L50 28" />
              <path d="M12 12 L20 20 M36 36 L44 44 M12 44 L20 36 M36 20 L44 12" />
            </svg>
          </div>
        </div>
      </div>

      {}
      <div className="relative h-4 w-full" aria-hidden="true">
        <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 100 16" fill="var(--foreground)">
          <polygon points="0,0 4,16 8,0 12,16 16,0 20,16 24,0 28,16 32,0 36,16 40,0 44,16 48,0 52,16 56,0 60,16 64,0 68,16 72,0 76,16 80,0 84,16 88,0 92,16 96,0 100,16 100,0" />
        </svg>
      </div>
    </section>;
}